import React, { createContext, useContext, useEffect, useReducer, useRef, useState } from 'react';
import { Header, Icon, Label, List, Menu, Modal, Popup, Segment, Sidebar } from 'semantic-ui-react';
import { createScheduleTypes } from '../../../projectSpecific/sports/cnr/reducers/CreateSportsReducer';
import { CreatePlayoffContext } from '../../../projectSpecific/sports/create/CreatePlayoff';
import { CreateSportsSeasonContext } from '../../../projectSpecific/sports/create/CreateSeason';
import { CreateSportsContext } from '../../../projectSpecific/sports/create/CreateSports';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { calendarHandlers, calendarInitialState, calendarReducer } from '../../cnr/reducers/CalendarReducer';
import { formatItem, formatTypes } from '../../common/dateFormatting';
import { uniqueKey } from '../../common/keys';
import { gEnums } from '../../enums/globalEnums';
import Checker from '../forms/elements/Checker';
import { triMenu } from '../menus/TriMenu';
import { CalendarMonths } from './CalendarMonths';
import CalMonth from './CalMonth';
import CalSchedule from './CalSchedule';

const _monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'Decemeber']

const today = new Date()

export const CalendarContext = createContext();

export const ScheduleCalendarModal = (props) => {
  const { calendar_state } = props
  return <Modal key={uniqueKey('scm')} size={'small'} open={calendar_state.calOpen} style={{ marginTop: 30, top: 60 }}>
    <ScheduleCalendar {...props} />
  </Modal>
}

export const ScheduleCalendar = (props) => {

  const _asat = gEnums.availableSubActionTypes

  console.log('props', props)

  const {
    createScheduleType,
    handleDateSelect,
    currentDates,
    crossSectionDates,
    selectedSection,
    fip,
    subActionType: _subActionType,
    inputDate
  } = props ?? {}

  const trueDate = fip && fip.value ? new Date(fip.value) : null
  const _trueDate = inputDate ? new Date(inputDate) : null

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataOptions, settingsOptions } = aps_global ?? {}
  const { dateFormat } = dataOptions ?? {}
  const { useDarkMode } = settingsOptions ?? {}

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { subActionType } = createSports_state ?? {}

  // createSportsSeasonContext
  const createSportsSeasonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_state, createSportsSeason_handlers } = createSportsSeasonContext ?? {}
  const { sportsSeason_selected } = createSportsSeason_state ?? {}
  const { crossoverOn, seasonals, seasonals_fluid } = sportsSeason_selected ?? {}
  const { details: sportsDetails } = seasonals ?? {}
  const { scheduleDates_info } = seasonals_fluid ?? {}
  const {
    currentSectionCount,
    currentNeeded: currentNeeded_season,
    currentCount: currentCount_season
  } = scheduleDates_info ?? {}

  const { year: sportsYears, seasonStartDate } = sportsDetails ?? {}

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { playoffDates_current } = playoff_info ?? {}
  const { currentNeeded_playoff, currentCount: currentCount_playoff, currentLevelKey } = playoffDates_current ?? {}

  const _currentDates = currentDates
  const _currentCount = createScheduleType === createScheduleTypes.season ? currentCount_season : currentCount_playoff
  const _currentNeeded = createScheduleType === createScheduleTypes.season ? currentNeeded_season : currentNeeded_playoff

  const _firstDate_0 = seasonStartDate
    ? (() => {
      const [month, day, year] = seasonStartDate.split('/');
      return new Date(Number(year), Number(month) - 1, 1);
    })()
    : new Date(today.getFullYear(), today.getMonth(), 1);
  const _firstDate_1 = trueDate ? new Date(trueDate.getFullYear(), trueDate.getMonth(), 1) : new Date(today.getFullYear(), today.getMonth(), 1)
  const _firstDate_2 = _trueDate ? new Date(_trueDate.getFullYear(), _trueDate.getMonth(), 1) : new Date(today.getFullYear(), today.getMonth(), 1)

  const _firstDate = _firstDate_0 || _firstDate_2 || _firstDate_1
  const _selectedDate = _firstDate_0 || _trueDate || trueDate || _firstDate

  const init_state = {
    initDate: _firstDate,
    currentDate: _selectedDate,
    dateFormat: dateFormat ? dateFormat : formatTypes.shortestDate,
    singleSelect: handleDateSelect ? true : false
  }

  const [calendar_state, calendarDispatch] = useReducer(calendarReducer, calendarInitialState(init_state));
  const calendar_handlers = calendarHandlers(calendarDispatch, calendar_state)

  const {
    calListOn,
    currentDate,
    isModal,
    monthsVisible,
    selectedDate,
    selectedDates,
    selectedCSDates,
    selectOnly,
    singleSelect,
  } = calendar_state ?? {}

  const prevDatesRef = useRef([]);
  const prevCSDatesRef = useRef([]);

  useEffect(() => {
    calendar_handlers.handleAmmend_crossover(crossoverOn)
    // eslint-disable-next-line 
  }, [crossoverOn]);

  // UPDATE ON selectedDate
  useEffect(() => {
    handleDateSelect && singleSelect && selectedDate && handleDateSelect(selectedDate)
    // eslint-disable-next-line 
  }, [selectedDate]);

  useEffect(() => {
    if (_.isEqual(prevDatesRef.current, selectedDates)) return;
    prevDatesRef.current = selectedDates;
    if (selectedDates.length > 0) {
      switch (subActionType) {
        case _asat.createPlayoff:
          const playoffDateProps = { selectedDates, seasonValue: sportsYears, selectedSection }
          createPlayoff_handlers?.handleSelect_playoffDates(playoffDateProps)
          break;

        case _asat.createSeason:
          const seasonDateProps = { selectedDates, seasonValue: sportsYears, sectionTeamCount: currentSectionCount, selectedSection }
          createSportsSeason_handlers?.handleSelected_seasonDates(seasonDateProps)
          break;
        default:
        // nothing
      }
    }
  }, [selectedDates]);

  useEffect(() => {
    if (_.isEqual(prevCSDatesRef.current, selectedCSDates)) return;
    prevCSDatesRef.current = selectedCSDates;
    if (selectedCSDates.length > 0) {
      console.log('selectedCSDates', selectedCSDates)
      const seasonDateProps = { selectedCSDates, seasonValue: sportsYears, sectionTeamCount: currentSectionCount, selectedSection }
      createSportsSeason_handlers?.handleSelected_seasonDates(seasonDateProps)
    }
  }, [selectedCSDates]);

  useEffect(() => {
    // load the dates into the recuder
    _currentDates && calendar_handlers.handleSelectedDates(_currentDates, crossSectionDates, currentLevelKey)
    // eslint-disable-next-line 
  }, [_currentDates, currentLevelKey, crossSectionDates]);

  const handleTodayClick = (date, isCtrl) => calendar_handlers.handleDateSelect(date, isCtrl)
  const handleYearClick = (key) => calendar_handlers.handleYearSelect(key)
  const handleItemClick = (monthIndex) => calendar_handlers.handleItemClick(monthIndex)
  const handleMenuClick = (key, date) => calendar_handlers.handleMenuClick(key, date)
  const handleCrossover = () => createSportsSeason_handlers && createSportsSeason_handlers.handleSet_crossover()

  const calMonth = () => <CalMonth currentDate={currentDate} selectedDate={selectedDate} />

  const calMonths = () => {
    const _showCount = (_currentCount && _currentNeeded) || crossoverOn
    if (_showCount || 1 === 1) {
      // const color = _currentCount === _currentNeeded ? 'green' : 'red'
      return <div>
        <div style={{ textAlign: 'center', paddingBottom: '1em' }}>
          {/* <Label color={color}><Icon name='hashtag' />{'Date Count: '}{_currentCount}{' of '}{_currentNeeded}</Label> */}
          <Label color={crossoverOn ? 'green' : 'grey'} onClick={() => handleCrossover()}><Icon name={crossoverOn ? 'check' : 'circle'} />{'Crossover'}</Label>
        </div>
        <CalSchedule />
      </div>
    } else {
      return <CalSchedule />
    }

  }

  const cal = () => {
    switch (createScheduleType) {
      case createScheduleTypes.season:
      case createScheduleTypes.crossover:
      case createScheduleTypes.playoff:
        return calMonths()
      default:
        return calMonth()
    }
  }

  const selectAllToggle = () => <Checker handleClick={calendar_handlers.handleShowCalList} label={'Show Selected Dates'} item={{ key: 'showCalList' }} />

  const calList = () => {
    const items = []
    if (selectedDates) {
      selectedDates.forEach((si, index) => {
        items.push(<List.Item color={'blue'}>{(index + 1)}{' '}{si}</List.Item>)
      })
    }
    return <Segment><List divided relaxed>{items}</List></Segment>
  }

  let cn = 'seg-cal-full'
  if (useDarkMode) { cn += ' app-dark-mode' }

  const content = () => <Segment.Group className={cn}>
    {isModal && <Segment attached='top' >
      <Header as='h3'>Today</Header>
    </Segment>}
    <Sidebar.Pushable key={uniqueKey('cal', 'ss')} as={Segment}>
      <CalendarMonths calProps={{ months: _monthNames, year: currentDate ? currentDate.getFullYear() : null, isVisible: monthsVisible, handleItemClick, handleYearClick }} />
      <Sidebar.Pusher data-et={'pusher-seg'} >
        <Segment className={'seg-cal-select'} style={{ padding: 0, border: 0 }}>
          {triMenu(formatItem(formatTypes.monthYear, currentDate), handleMenuClick)}
          {!selectOnly && !handleDateSelect && selectAllToggle()}
          {_currentCount && _currentNeeded && <div style={{ textAlign: 'center', paddingBottom: '1em' }}>{'Count: '}{_currentCount}{' of '}{_currentNeeded}</div>}
          {!calListOn && cal()}
          {calListOn && calList()}
        </Segment>
      </Sidebar.Pusher>
    </Sidebar.Pushable>
    {isModal && <Segment attached='bottom' style={{ padding: 0 }}>
      <Menu widths={2} syle={{ border: 0, borderRadius: 0 }}>
        <Menu.Item name='Today' onClick={(e) => handleTodayClick(formatItem(formatTypes.date, today), e.shiftKey)} />
        <Menu.Item name='Cancel' onClick={() => calendar_handlers.handleClose()} />
      </Menu>
    </Segment>}
  </Segment.Group>

  switch (createScheduleType) {
    case createScheduleTypes.season:
    case createScheduleTypes.playoff:
      return <CalendarContext.Provider value={{ calendar_state, calendar_handlers }}>
        {calMonths()}
      </CalendarContext.Provider>
    default:
      return <CalendarContext.Provider value={{ calendar_state, calendar_handlers }}>
        {content()}
      </CalendarContext.Provider>
  }

}

export const CalPopup = (props) => {

  const [isOpen, setIsOpen] = useState(false)

  return <Popup
    content={<ScheduleCalendar props={props} />}
    on='click'
    pinned
    position='bottom left'
    basic
    size='tiny'
    style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)' }}
    trigger={props.trigger}
    open={isOpen}
    onOpen={() => setIsOpen(true)}
    onClose={() => setIsOpen(false)}
  // closeOnDocumentClick
  />
}

export const CalendarDirect = (props) => {

  const { handleSelectedDate } = props

  const init_state = {}
  const [calendar_state, calendarDispatch] = useReducer(calendarReducer, calendarInitialState(init_state));
  const calendar_handlers = calendarHandlers(calendarDispatch, calendar_state)
  const { selectedDate } = calendar_state ?? {}

  useEffect(() => {
    handleSelectedDate(selectedDate)
    // eslint-disable-next-line 
  }, [selectedDate]);

  return <ScheduleCalendar  {...props} calendar_state={calendar_state} calendar_handlers={calendar_handlers} />
}